// Title casing for job titles, which employers type in any case (QUAL-007.1).
// Same rules as RefugeeJL src/utils/formatTitle.js — keep the two in sync.
// - trims and collapses spaces
// - capitalizes words that are entirely lowercase ("carpenter" -> "Carpenter"),
//   including parts joined by "-" or "/" ("framer-carpenter" -> "Framer-Carpenter")
// - leaves any word that already has a capital alone, so acronyms and
//   deliberate casing (HVAC, ECE, McDonald's) survive
// - keeps short joining words lowercase unless they start the title
// - an all-caps title of 2+ words ("WELDER HELPER") is treated as lowercase first
// Applied when a job is saved (Postjob / UpdateJob).
const MINOR_WORDS = new Set(['a', 'an', 'and', 'as', 'at', 'by', 'for', 'in', 'of', 'on', 'or', 'the', 'to', 'with']);
// After these prefixes the next part stays lowercase: "Co-ordinator", not "Co-Ordinator".
const HYPHEN_PREFIXES = new Set(['co', 're', 'pre', 'non', 'e', 'sub', 'semi', 'multi', 'anti', 'inter']);

function capitalizePart(part, isFirstWord) {
  const match = /^([^A-Za-z]*)([A-Za-z].*)$/.exec(part);
  if (!match) return part;
  const [, lead, rest] = match;
  if (rest !== rest.toLowerCase()) return part;
  const bare = rest.replace(/[^a-z']+$/, '');
  if (!isFirstWord && !lead && MINOR_WORDS.has(bare)) return part;
  return lead + rest.charAt(0).toUpperCase() + rest.slice(1);
}

export function formatTitle(title) {
  if (typeof title !== 'string') return title;
  let text = title.trim().replace(/\s+/g, ' ');
  const letters = text.replace(/[^A-Za-z]/g, '');
  if (letters && letters === letters.toUpperCase() && text.split(' ').length >= 2) {
    text = text.toLowerCase();
  }
  return text
    .split(' ')
    .map((word, i) =>
      word
        .split(/([-/])/)
        .map((part, j, parts) => {
          if (part === '-' || part === '/') return part;
          const afterPrefix = j >= 2 && parts[j - 1] === '-' && HYPHEN_PREFIXES.has(parts[j - 2].toLowerCase());
          return afterPrefix ? part : capitalizePart(part, i === 0 && j === 0);
        })
        .join('')
    )
    .join(' ');
}
